import { data } from "autoprefixer";
import { APIMethod } from "./apikit";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const multipartHeaders = {
  "Content-Type": "multipart/form-data; boundary=12345",
  Accept: "application/json",
};

export const LoginApi = (data) => {
  return APIMethod.POST("admin/sign-in", data, headers);
};

export const forgotPasswordApi = (data) => {
  return APIMethod.POST("admin/forgot-password", data, headers);
};

export const changePasswordApi = (data) => {
  return APIMethod.POST("admin/change-password", data, headers);
};

export const skipApi = (data) => {
  return APIMethod.GET("admin/skip", data, headers);
};

export const checkLinkApi = (data) => {
  return APIMethod.POST("admin/forgot-link-verify", data, headers);
};

export const resetPasswordApi = (data) => {
  return APIMethod.POST("admin/reset-password", data, headers);
};

export const logutApi = () => {
  return APIMethod.GET("admin/logout", headers);
};

////////////  organization Api ////////////////

export const createOrgApi = (data) => {
  return APIMethod.POST("admin/create-organisation", data, multipartHeaders);
};

export const editOrgApi = (data) => {
  return APIMethod.POST("admin/edit-organisation", data, multipartHeaders);
};

export const orglistApi = (data) => {
  return APIMethod.POST("admin/organisation-list", data, headers);
};

export const orgUserListApi = (data) => {
  return APIMethod.POST("organisation/user-list", data, headers);
};

export const editOrgUserApi = (data) => {
  return APIMethod.PUT("organisation/edit-user-department", data, headers);
};

////////////  U S E R __ A P I ////////////////

export const accountStatusApi = () => {
  return APIMethod.GET("admin/account-status", headers);
};

export const coreValueStatusApi = () => {
  return APIMethod.GET("admin/core-value-status", headers);
};

export const userListApi = (data) => {
  return APIMethod.POST("admin/user-list", data, headers);
};

export const userDetailApi = (data) => {
  return APIMethod.POST("admin/get-user-detail", data, headers);
};

export const freezeProfileApi = (data) => {
  return APIMethod.POST("admin/freeze-profile", data, headers);
};

export const removeProfileApi = (data) => {
  return APIMethod.DELETE(`admin/delete/${data.id}`, headers);
};

export const emailSearchApi = (data) => {
  return APIMethod.POST("admin/email-search", data, headers);
};

////////////  C O M M U N I T Y__A P I ////////////////
export const createPost = (data) => {
  return APIMethod.POST("admin/create-post", data, multipartHeaders);
};

export const removePostApi = (data) => {
  return APIMethod.POST("admin/delete-post", data, headers);
};

////////////  R E P O R T__A P I ////////////////
export const reportListApi = (data) => {
  return APIMethod.POST("admin/report-list", data, headers);
};

export const reportDataApi = (data) => {
  return APIMethod.GET("admin/report-data", data, headers);
};

export const removeReportApi = (data) => {
  return APIMethod.POST("/admin/remove-post", data, headers);
};

////////////Dashboard api ///////////////

export const dashboardApi = (data) => {
  console.log("my api is hitting", data);
  return APIMethod.POST("organisation/dashboard", data, headers);
};

export const userDeleteApi = (data) => {
  return APIMethod.DELETE(`organisation/delete/${data}`, headers);
};

export const addUserApi = (data) => {
  return APIMethod.POST("organisation/add-user-csv", data, headers);
};

export const SignupsApi = (data) => {
  return APIMethod.POST("organisation/signups-gender-based", data, headers);
};

export const topUsageApi = (data) => {
  return APIMethod.POST("organisation/top-usage", data, headers);
};
export const moodsLoogedApi = (data) => {
  return APIMethod.POST("organisation/get-moods-logged", data, headers);
};
export const thoughtsLoggedApi = (data) => {
  return APIMethod.POST("organisation/get-thoughts-logged", data, headers);
};
export const postActivityApi = (data) => {
  return APIMethod.POST("organisation/get-post-activity", data, headers);
};
export const wellnesActivityApi = (data) => {
  return APIMethod.POST("organisation/get-wellness-activity", data, headers);
};
export const averageMoodsApi = (data) => {
  return APIMethod.POST("organisation/get-average-log", data, headers);
};
export const wellnessChartApi = (data) =>
  APIMethod.POST("organisation/who-willness-index", data, headers);

///// inner Circle Api ///////

export const innerCircleApi = (data) => {
  return APIMethod.POST("organisation/get-inner-circle", data, headers);
};
export const createInnerCircleApi = (data) => {
  return APIMethod.POST("organisation/create-inner-circle", data, headers);
};
export const innerCircleDetailApi = (data) => {
  return APIMethod.POST("organisation/inner-circle-detail", data, headers);
};

export const AdminInnerCircleDetailApi = (data) => {
  return APIMethod.POST("admin/inner-circle-detail", data, headers);
};

export const addUserInCircleApi = (data) => {
  return APIMethod.POST(
    "organisation/add-user-in-circle",
    data,
    multipartHeaders
  );
};
export const getCirclePostListAPI = (data) =>
  APIMethod.POST("organisation/circle-post-list", data, headers);

export const adminGetCirclePostListAPI = (data) =>
  APIMethod.POST("admin/circle-post-list", data, headers);
export const getCommentListApi = (data) =>
  APIMethod.POST("organisation/post-comment-list", data, headers);

/////////////////  Create Admin Api /////////////

export const createAdminApi = (data) =>
  APIMethod.POST("admin/create-org-admin", data, headers);

export const adminListApi = (data) =>
  APIMethod.POST("admin/org-admin-list", data, headers);

export const ActiveAdminApi = (data) =>
  APIMethod.POST("admin/active-admin-account", data, headers);

export const DeleteAdminApi = (data) =>
  APIMethod.POST("admin/delete-admin-account", data, headers);

export const innerCircleGloabListApi = (data) =>
  APIMethod.POST("admin/get-inner-circle-list", data, headers);

///// ENCORAGEMENT GROUPS SAGA //////

export const addEncouragementGroupApi = (data) => {
  return APIMethod.POST(
    "admin/encouragement/create-group",
    data,
    multipartHeaders
  );
};

export const editEncouragementGroupApi = (data) => {
  return APIMethod.POST(
    "admin/encouragement/edit-group",
    data,
    multipartHeaders
  );
};

export const encouragementGroupListApi = (data) => {
  return APIMethod.POST("admin/encouragement/group-list", data, headers);
};

//////////////  POST LIST API ///////////////

export const PostListApi = (data) => {
  return APIMethod.POST("admin/post-list", data, headers);
};

///////////////// Encourgment Group Api ///////////////////

export const encouragementPostlistApi = (data) => {
  return APIMethod.POST("admin/encouragement/group-post-list", data, headers);
};

export const encouragementGetAllDataApi = (data) => {
  return APIMethod.GET("admin/encouragement/all-data", headers);
};

///////////////Report List Api ///////////////

export const reportDetailApi = (data) => {
  return APIMethod.POST("admin/report-detail", data, headers);
};

export const userCommentListApi = (data) =>
  APIMethod.POST("admin/post-comment-list", data, headers);
export const makeSuperUserApi = (data) =>
  APIMethod.POST("admin/super-user", data, headers);

/////__M E S S A G E   A P I__//////

export const messageListApi = (data) => {
  return APIMethod.POST("admin/contact-us-list", data, headers);
};

/////__N O T I F I C A T I O N   A P I__//////

export const notificationListApi = (data) =>
  APIMethod.POST("admin/schedule-notification-list", data, headers);

export const createNewPushNotificationApi = (data) =>
  APIMethod.POST("admin/create-schedule-notification", data, headers);

export const editPushNotificationApi = (data) =>
  APIMethod.POST("admin/edit-schedule-notification", data, headers);

export const deletePushNotificationApi = (data) =>
  APIMethod.POST("admin/delete-schedule-notification", data, headers);

/////__S E T T I N G   A P I__//////

export const createSubAdminApi = (data) => {
  return APIMethod.POST("admin/create-sub-admin", data, headers);
};

export const createSubAdminListApi = (data) => {
  return APIMethod.POST("admin/sub-admin-list", data, headers);
};
export const getAccessListApi = (data) => {
  return APIMethod.GET("admin/get-access", headers);
};
export const getWhoScoreApi = (data) => {
  return APIMethod.POST("admin/who-score", data, headers);
};

export const uploadAvatarApi = (data) => {
  return APIMethod.POST("admin/upload-avatar", data, multipartHeaders);
};
export const RequestScoreApoi = (data) => {
  return APIMethod.POST("admin/request-assesment", data, headers);
};
export const editRequestScoreApoi = (data) => {
  return APIMethod.POST("admin/edit-assesment", data, headers);
};

export const upcomingAssessmentApi = (data) => {
  return APIMethod.POST("admin/upcoming-assesment", data, headers);
};

export const encourgmentScoreApi = () => {
  return APIMethod.GET("admin/encouragement/all-data", headers);
};

export const activeMainAdminApi = (data) => {
  return APIMethod.POST("admin/active-admin-account", data, headers);
};

export const deleteMainAdminApi = (data) => {
  return APIMethod.POST("admin/delete-admin-account", data, headers);
};

export const deleteCircleApi = (data) =>
  APIMethod.POST("admin/delete-circle", data, headers);

export const editCircleApi = (data) =>
  APIMethod.PUT("admin/edit-circle", data, headers);

export const getAffirmationApi = (data) =>
  APIMethod.POST("/admin/get-affirmation", data, headers);

export const getJournalApi = (data) =>
  APIMethod.POST("admin/get-journal", data, headers);

export const getTherapyApi = (data) =>
  APIMethod.POST("admin/get-therapy", data, headers);

// Tools API
export const toolsMoodsLoggedApi = (data) =>
  APIMethod.POST("admin/all-mood-logged", data, headers);
export const toolsThoughtsLoggedApi = (data) =>
  APIMethod.POST("admin/all-thoughts-logged", data, headers);
export const toolsAverageMoodApi = (data) =>
  APIMethod.POST("admin/get-average-log", data, headers);
export const toolsTopUsageApi = (data) => {
  return APIMethod.GET("admin/top-usage", data, headers);
};
export const editAdminApi = (data) =>
  APIMethod.POST("admin/edit-sub-admin", data, headers);

/// Comment on post API  ///////

export const commentOnPostApi = (data) =>
  APIMethod.POST("admin/comment-on-post", data, headers);

// C O M M O N  A P I
export const removeCommentApi = (data) =>
  APIMethod.POST("admin/delete-comment", data, headers);

//TOXIC API

export const toxicApi = (data) => APIMethod.POST("admin/toxicity", data);

////////////  Department Api ////////////////

export const createDepartmentApi = (data) => {
  return APIMethod.POST("admin/add-department", data, headers);
};

export const deleteDepartmentApi = (id) => {
  return APIMethod.DELETE(`admin/delete-department/${id}`, headers);
};

export const editDepartmentApi = (data) => {
  return APIMethod.PUT("admin/edit-department", data, headers);
};

export const listDepartmentApi = (data) => {
  return APIMethod.POST("admin/department-list", data, headers);
};

/////direct care//////
export const directCareListApi = (data) => {
  return APIMethod.POST("admin/booking-slot-list", data, headers);
};

export const cancilRequestApi = (data) => {
  return APIMethod.POST("admin/cancel-booking-slot", data, headers);
};

/////// manage pros /////////
export const proListApi = (data) => {
  return APIMethod.POST("admin/apply-pro-list", data, headers);
};
export const updateProStatusApi = (data) => {
  return APIMethod.POST("admin/update-pro-status", data, headers);
};
export const proProfile = (data) => {
  return APIMethod.POST("admin/get-pro-profile", data, headers);
};
export const profileListApi = (data) => {
  return APIMethod.POST("admin/get-pro-data", data, headers);
};

/////// Engagement Farming /////////

export const createUserApi = (data) => {
  return APIMethod.POST("admin/create-user", data, multipartHeaders);
};

export const avatarListApi = () => {
  return APIMethod.GET("admin/get-avatar", headers);
};

export const genderListApi = (data) => {
  return APIMethod.POST("admin/identity-search", data, headers);
};

export const engagementPostListApi = (data) => {
  return APIMethod.POST("admin/all-post-list", data, headers);
};

export const commentForDummyUserApi = (data) =>
  APIMethod.POST("admin/comment-for-dummy-user", data, headers);

export const dummyUserListApi = (data) =>
  APIMethod.POST("admin/dummy-user-list", data, headers);

export const createPostDummyUserApi = (data) =>
  APIMethod.POST("admin/create-post-for-dummyUser", data, headers);

export const deleteVideoListApi = (data) => {
  return APIMethod.POST("admin/delete-post", data, headers);
};

// Subscriptions
export const verifySubscriptionTokenApi = (data) => {
  return APIMethod.POST("user/verify-payment-token", data, headers);
};

export const userPurchaseApi = (data) => {
  return APIMethod.POST("user/user-purchase", data, headers);
};

export const userProApi = (data) => {
  return APIMethod.POST("user/pro-purchase", data, headers);
};

export const bookSlotApi = (data) => {
  return APIMethod.POST("/profession/booking-slot", data, headers);
};

export const verifyPromoCodeApi = (data) => {
  return APIMethod.POST("user/verify-promo", data, headers);
};

//for user

export const createUserPasswordApi = (data) => {
  return APIMethod.POST("user/reset-password", data, headers);
};
export const userLoginApi = (data) => {
  return APIMethod.POST("user/login", data, headers);
};

export const signUpApi = (data) => {
  return APIMethod.POST("user/signUp", data, headers);
};

export const otpApi = (data) => {
  return APIMethod.POST("user/verify-otp", data, headers);
};

//If you have better way, please correct this
export const getWebTokenApi = (payload) => {
  return APIMethod.POST("user/payment-token", { promoref: payload?.promoRef, type: payload?.type }, { headers, "x-access-token": `Bearer ${payload?.token}`, Authorization: null });
};

export const updateBookingDataAPI = (payload) => {
  console.log(payload, "this is payload")
  return APIMethod.POST(`profession/update-booking-data`, { bookingId: payload?.bookingId, date: payload?.date }, { headers, "x-access-token": `Bearer ${payload?.token}`, Authorization: null });
}

export const cancelBookingAPI = (data) => {
  return APIMethod.POST(`profession/cancel-booking-slot`, data, headers);
}


export const encouragementgroupDeleteApi = (data) => {
  return APIMethod.POST("admin/encouragement/delete-group", data, headers);
};
